module.exports = __webpack_public_path__ + "static/christianwork8-59038f431909248963c7d1d6026d1d7f.jpg";